/**
* Double Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Double Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'double-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.double-marquee__splide' ).length ) {
        $( '.double-marquee__splide' ).each( function( index, element ) {
          const direction = index % 2 === 0 ? 'rtl' : 'ltl';
          const slider = new Splide( $( element )[0], {
            type: 'loop',
            perPage: 3,
            focus: 'center',
            arrows: false,
            direction: direction,
            pagination: false,
            gap: '2rem',
            breakpoints: {
              768: {
                fixedWidth: `250px`,
              },
            },
          } );

          slider.mount( {AutoScroll} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'double-marquee', COMPONENT );
} )( app );
